<template>
    <div
        class="bg-white p-3 rounded shadow content"
        @mouseenter="showDetails"
        @mouseleave="hideDetails"
    >
        <div
            v-if="cert_holder.gold_company_logo"
            class="logo flex flex-col justify-between"
            :class="reveal ? 'reveal' : ''"
        >
            <img
                :src="cert_holder.gold_company_logo"
                :alt="cert_holder.title"
                class="block rounded w-full h-auto mb-1"
            >
            <h3 class="mb-1">{{ cert_holder.title }}</h3>
        </div>
        <transition name="fade">
            <div class="data" :class="reveal ? 'reveal' : ''">
                <p>
                    <span v-if="cert_holder.gold_certification_holder_since" class="mb-1">
                        Gold holder since:
                        <strong>{{ cert_holder.gold_certification_holder_since }}</strong>
                        <br>
                    </span>
                    <span v-if="cert_holder.product_category" class="mb-1">
                        Product Category:
                        <strong>{{ cert_holder.product_category }}</strong>
                        <br>
                    </span>
                    <span v-if="cert_holder.installation_category" class="mb-1">
                        Installation Category:
                        <strong>{{ cert_holder.installation_category }}</strong>
                    </span>
                </p>
                <div class v-if="cert_holder.pdf_certificates.length > 0">
                    <strong class="text-sm mb-1 block">View Certificate(s):</strong>
                    <div v-for="cert in cert_holder.pdf_certificates" :key="cert.url">
                        <a :href="cert.url" target="_blank" class="block mb-2">{{ cert.title }}</a>
                    </div>
                </div>

                <span v-if="cert_holder.gold_website_url">
                    <a
                        :href="cert_holder.gold_website_url"
                        class="btn btn-white mt-4 mb-1 inline-flex items-center"
                        target="_blank"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="fill-current w-4 h-4 mr-2"
                            viewBox="0 0 20 20"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M12 17.75a8 8 0 0 0 4-2.46V9a2 2 0 0 1-2-2V3.07a7.95 7.95 0 0 0-3-1V3a2 2 0 0 1-2 2v1a2 2 0 0 1-2 2v2h3a2 2 0 0 1 2 2v5.75zm-4 0A8 8 0 0 1 2.25 8H4v2.5c0 .83.67 1.5 1.5 1.5H6v1a2 2 0 0 0 2 2v2.75zM10 20a10 10 0 1 0 0-20 10 10 0 0 0 0 20z"
                            ></path>
                        </svg>
                        Website
                    </a>
                </span>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: ["cert_holder"],
    data() {
        return {
            reveal: false
        };
    },
    methods: {
        showDetails() {
            this.reveal = true;
        },
        hideDetails() {
            setTimeout(() => {
                this.reveal = false;
            }, 700);
        }
    }
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
    .logo {
        transition: min-height 0.5s cubic-bezier(0.075, 0.82, 0.165, 1) 0.5s;
        min-height: 300px;
        &.reveal {
            transition: min-height 0.5s ease-in-out;
            min-height: 200px;
        }
    }
    .data {
        transition: max-height 0.5s cubic-bezier(0.075, 0.82, 0.165, 1) 0.5s;
        @apply overflow-hidden;
        max-height: 0;
        &.reveal {
            max-height: 250px;
            transition: max-height 0.5s ease-in-out;
        }
    }
}
</style>
